/**
 * Default parameter values for KB Search
 */
export const kbSearchDefaults = {
  collectionId: '',
  credentialId: '',
  query: '',
  topK: 5,
  minScore: 0.7,
  includeContent: true,
  outputFormat: 'full',
  toolDescription: 'Search the knowledge base for relevant information'
};
